import { faNewspaper } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule } from '@domain-group/suit-theme'

import ListBlankState from '@components/ListBlankState'
import PublicationEditionsTable from './PublicationEditionsTable'
import useUpcomingPaginations from './hooks/useUpcomingPaginations'

export const icon = faNewspaper

export const configOptions = () => {}

interface UpcomingPaginationsProps {
  customOptions: {
    customization?: {
      display_mode?: string,
      title?: string,
    },
  },
  editing: boolean,
}

const UpcomingPaginations = (props: UpcomingPaginationsProps) => {
  const { customOptions, editing } = props

  const publicationEditionsPayload = useUpcomingPaginations({ performHttpRequests: true })

  const {
    loading,
    publicationEditions,
    hasPublicationEditions,
  } = publicationEditionsPayload

  const { customization } = customOptions
  const { title } = customization || {}

  return (
    <DashboardModule
      boxProps={{ marginBottom: 0 }}
      contentBoxProps={{ flexDirection: 'column' }}
      editing={editing}
      loading={loading}
      title={title || 'Upcoming Paginations'}
    >
      {!hasPublicationEditions && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Upcoming Paginations present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}

      {hasPublicationEditions && (
        <DashboardModule.ScrollableSection>
          <PublicationEditionsTable publicationEditions={publicationEditions} />
        </DashboardModule.ScrollableSection>
      )}
    </DashboardModule>
  )
}

export default UpcomingPaginations
